/**
 * PaymentListContainer
 * --
 */
import React from 'react';
import OrderList from 'routes/shop.routes/shop.orders/OrderList';

const PaymentListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <OrderList />
    </>
  );
};

export default PaymentListContainer;
